export default {
  performanceMetrics: {
    activeUsers: "Active Users",
    creditsUsed: "Credits Used",
    avgCompletionRate: "Avg. Completion Rate",
    topUsers: "Top Active Users",
    noActiveUsers: "No active users",
  },

  userActivityTable: {
    title: "User Activity",
    searchPlaceholder: "Search users...",
    users: "users",
    headers: {
      name: "Name",
      email: "Email",
      activities: "Activities",
      creditsUsed: "Credits Used",
      creditsRemaining: "Credits Remaining",
      completionRate: "Completion Rate",
      lastActivity: "Last Activity",
      status: "Status",
      actions: "Actions",
    },
    viewDetails: "View Details",
    active: "Active",
    inactive: "Inactive",
    dormant: "Dormant",
    neverActive: "Never Active",
    never: "Never",
    noUsers: "No Users",
    noUsersDescription: "There are no users available at this time.",
  },

  lessonProgressChart: {
    title: "Course Progress",
    timeRange: "Period: {days} days",
    totalUsers: "Total Users",
    avgCompletion: "Avg. Completion",
    topPerformers: "Top Performers",
    noData: "No data to display",
  },

  creditUsageChart: {
    title: "Credit Usage",
    totalCredits: "Total Credits",
    usedCredits: "Used Credits",
    availableCredits: "Available Credits",
    utilizationRate: "Utilization Rate",
    distributionRate: "Distribution Rate",
    utilization: "Utilization",
    topUsers: "Top Credit Users",
    used: "Used",
    distributed: "Distributed",
    available: "Available",
    allocation: "Credit Allocation",
    noUsage: "No credit usage",
  },

  recentActivity: {
    title: "Recent Activity",
    lastDays: "Last {days} days",
    journeyStarted: "Started course",
    challengeStarted: "Started challenge",
    gymStarted: "Started training",
    learningPath: "Learning Path",
    trainingSession: "Training Session",
    status: {
      completed: "Completed",
      inProgress: "In Progress",
      failed: "Failed",
      unknown: "Unknown",
    },
    timeAgo: {
      seconds: "{count} seconds ago",
      minutes: "{count} minutes ago",
      hours: "{count} hours ago",
      days: "{count} days ago",
    },
    noActivity: "No Activity",
    noActivityDescription: "No activity recorded in the last {days} days.",
    viewAll: "View All",
  },

  userDetailModal: {
    never: "Never",
    close: "Close",
    stats: {
      totalActivities: "Total Activities",
      creditsUsed: "Credits Used",
      completionRate: "Completion Rate",
      avgSessionTime: "Avg. Session Time",
    },
    userInfo: {
      title: "User Information",
      lastSignIn: "Last Sign In",
      creditsAllocated: "Credits Allocated",
      creditsRemaining: "Credits Remaining",
      lessonsCompleted: "Courses Completed",
      gamesCompleted: "Games Completed",
    },
    progress: {
      title: "Progress",
      creditUtilization: "Credit Utilization",
      lessonCompletion: "Course Completion",
    },
    recentGames: {
      title: "Recent Games",
      noGames: "No recent games",
    },
    recentJourneys: {
      title: "Recent Courses",
      learningPath: "Learning Path",
      progress: "Step {reached}/{total}",
      noJourneys: "No recent courses",
    },
    status: {
      completed: "Completed",
      inProgress: "In Progress",
      failed: "Failed",
      unknown: "Unknown",
    },
    moduleType: {
      challenge: "Challenge",
      gym: "Training",
      unknown: "Unknown",
    },
  },
};
